import { render, staticRenderFns } from "./PrestacaoContasMensal.vue?vue&type=template&id=ba5f12ec"
import script from "./PrestacaoContasMensal.vue?vue&type=script&lang=js"
export * from "./PrestacaoContasMensal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports